<template>
  <!-- <div class="activiti"
    v-for="(tag, indexTag) in TagsDataFilter"
    :key="indexTag"
  >
    <h3 class="activiti__title">
      {{ tag?.UniversalTagName }}
    </h3>
    <div :class="{
        'activiti__list': tag.UniversalTagId !== ActiveId,
        'activiti__list_full': tag.UniversalTagId == ActiveId
      }"
    >
        <BaseBtn
          v-for="(item, indexItem) in tag?.InnerTags"
          :key="indexItem"
          :text="item?.Name"
          white
          :active="item.IsActive"
          @clickBtn="activeTag(item.Id, indexTag, indexItem, item)"
        />
      <div class="activiti__block-adder">
        <BlockAdder
          @click="goToAdd()"
        >
        </BlockAdder>
      </div>
    </div>
    <div class="activiti__show-button">
      <BaseBtn
        v-if="tag.UniversalTagId !== ActiveId"
        @click="getFullList(tag?.UniversalTagId)"
        blue
        text="Все теги"
      />
    </div>
  </div> -->
  <BlockAdder
    class="block-add"
    @click="goToAdd()"/>
  <DataTable
  ref="dt"
  :value="TagsDataFilter"
  v-model:selection="selectedTags"
  data-key="Id"
  scrollable
  scroll-height="380px"
  :filters="filters"
  :rows="20"
  paginator
  :loading="false"
  :rows-per-page-options="[20, 60, 100]"
  responsive-layout="scroll"
  filter-display="row"
    show-gridlines
    selection-mode="single"
  class="p-datatable-sm"
>
<Column field="Name" header="Название" sortable>
  <template #body="{ data }">
    <div class="tag-item">
      <Checkbox
        :modelValue="data.IsActive"
        :binary="true"
        class="tag-item__checkbox"
        @change="activeTag(data.Id, indexTag, indexItem, data)"
      />
      <p class="tag-item__label">{{ data.Name }}</p>
    </div>
  </template>
  <template #filter>
    <InputText
      v-model="headerFilter"
      type="text"
      @input="onHeaderFilterChange"
      placeholder="Поиск по названию"
    />
  </template>
</Column>
  <Column field="UniversalTagId" header="Направление деятельности" sortable>
    <template #body="{ data }">
      {{ getTagNameById(data.UniversalTagId) }}
    </template>
    <template #filter>
      <Dropdown
        v-model="directionFilter"
        @change="onDirectionFilterChange"
        :options="universalTagOptions"
        option-label="label"
        option-value="value"
        placeholder="Все"
        class="p-column-filter"
        :showClear="true"
      />
    </template>
  </Column>

  <Column header-style="width: 8rem">
    <template #body="slotProps">
      <Button
        icon="pi pi-pencil"
        rounded
        text
        small
        @click="$emit('editTag', slotProps.data)"
      />
      <Button
        icon="pi pi-trash"
        rounded
        text
        small
        severity="danger"
        @click="$emit('confirmDeleteTag', slotProps.data)"
      />
    </template>
  </Column>
</DataTable>

  <AddTagsModal
    v-if="AddtagsModalVisible"
    :categoryId="activitiesId"
  />
</template>

<script>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'

// import BaseBtn from '@/components/ui/BaseBtn.vue'
import BlockAdder from '@/components/elements/BlockAdder.vue'
import AddTagsModal from '@/components/modals/AddTagsModal.vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import Button from 'primevue/button'
import Checkbox from 'primevue/checkbox'
import { FilterMatchMode } from 'primevue/api'

export default {
  name: 'TagsModalActivitiesNew',
  components: {
    // BaseBtn,
    BlockAdder,
    AddTagsModal,
    DataTable,
    Column,
    InputText,
    Dropdown,
    Button,
    Checkbox
  },
  props: {
    activitiesId: {
      type: Number,
      default: 0
    }
  },
  setup (props) {
    const store = useStore()
    const headerFilter = ref(null)
    const directionFilter = ref(null)
    const onHeaderFilterChange = () => {
      filters.value.Name.value = headerFilter.value
    }

    const onDirectionFilterChange = () => {
      filters.value.UniversalTagId.value = directionFilter.value
    }

    const TagsDataFilter = computed(() => {
      return store.getters.getTagsDataFilter
    })
    const AddtagsModalVisible = computed(() => {
      return store.getters.getShowAddTagsEditor
    })

    const universalTagOptions = computed(() => {
      return universalTagsMap.map(tag => ({
        label: tag.name,
        value: tag.id
      }))
    })

    const universalTagsMap = [
      { name: 'Группа компаний', id: 1 },
      { name: 'Обучение', id: 2 },
      { name: 'Производство', id: 3 },
      { name: 'Инжиниринговые услуги', id: 4 },
      { name: 'Программное обеспечение', id: 5 }
    ]

    // Получить имя по ID
    const getTagNameById = (id) => {
      const tag = universalTagsMap.find(t => t.id === id)
      return tag ? tag.name : '—'
    }

    const filters = ref({
      Name: { value: null, matchMode: FilterMatchMode.CONTAINS },
      UniversalTagId: { value: null, matchMode: FilterMatchMode.EQUALS },
      IsActive: { value: null, matchMode: FilterMatchMode.EQUALS }
    })

    const ActiveId = ref(null)

    const activeTag = (id, indexTag, indexItem, item) => {
      store.commit('SetChangeTagsObj', item)
      // store.commit('SetSelectedTags', {
      //   id,
      //   indexTag,
      //   indexItem
      // })
      item.IsActive = !item.IsActive

      if (props.activitiesId === 3) {
        store.dispatch('setCheckInnerTag', item)
      } else if (props.activitiesId === 2) {
        store.dispatch('setCheckInnerTagNews', item)
      } else if (props.activitiesId === 4) {
        store.dispatch('setCheckInnerTagServices', item)
      }
    }

    const goToAdd = () => {
      store.commit('SetShowAddTagsEditor', true)
    }

    const getFullList = (id) => {
      ActiveId.value = id
    }

    return {
      goToAdd,
      AddtagsModalVisible,
      TagsDataFilter,
      getFullList,
      activeTag,
      ActiveId,
      universalTagOptions,
      getTagNameById,
      filters,
      headerFilter,
      onHeaderFilterChange,
      onDirectionFilterChange,
      directionFilter,
      universalTagsMap
    }
  }
}
</script>

<style lang="scss" scoped>
.activiti {
  margin-bottom: 30px;

  &__title {
    font-weight: 500;
    font-size: 20px;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: start;
  }

  &__list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 16px;
    padding: 16px 0;

    &_full {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
      margin-bottom: 16px;
      padding: 16px 0;
    }
  }

  &__show-button {
    display: flex;
    justify-content: space-around;
  }
}

.tag-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

::v-deep
  .base-button  {
    height: 38px;
  }

  :deep(.block-adder__button) {
    margin-right: 0;
  }
.block-add {
  justify-content: flex-end !important;
}
//Стили таблицы
:deep(.p-datatable-thead) {
  th {
    font-weight: 400 !important;
    font-size: 16px !important;
    color: #787878 !important;
    background-color: #E6E6E6 !important;
    border-right: 1px solid #787878 !important;
    border-bottom: none !important;

    &:last-child {
      border-right: none !important;
    }
  }
}
:deep(.p-datatable-tbody) {
  td {
    font-weight: 400 !important;
    font-size: 16px !important;
    color: #000000 !important;
    border: 1px solid #E6E6E6 !important;
  }
  tr.p-highlight {
    background: #DEDEDE !important;
    &:focus, &:active {
      outline: none !important;
      border: none !important;
    }
  }
}
:deep(.p-inputtext) {
  border: 1px solid #000000;
  width: 100% !important;
  padding: 6px 12px !important;
  &:hover {
    border-color: #000000 !important;
  }
  &:focus {
    box-shadow: none !important;
    border-color: #000000 !important;
  }
}
:deep(.p-dropdown) {
  border: 1px solid #C8C8C8 !important;
  background-color: #F5F5F5 !important;
  /* Состояние фокуса */
  &.p-focus {
    box-shadow: none !important;
    outline: none !important;
    border-color: #000000 !important;
  }
  /* Состояние ховера */
  &:not(.p-disabled):hover {
    border-color: #000000 !important;
  }
  /* Внутренние элементы */
  .p-dropdown-label {
    &:focus {
      box-shadow: none !important;
      outline: none !important;
    }
  }
  /* Триггер (стрелка) */
  .p-dropdown-trigger {
    &:focus {
      outline: none !important;
    }
  }
}

:deep(.header-with-filter) {
  width: 100%;
  .p-dropdown {
    position: relative !important;
    width: 100% !important;
    min-width: 100% !important;
    font-size: 16px !important;
    .p-dropdown-trigger {
      position: absolute;
      right: 0;
      top: calc(50% - 9px);
    }
  }
  .p-inputtext {
    width: 100% !important;
    min-width: 100% !important;
    font-size: 16px !important;
  }
}
:deep(.p-dropdown-item) {
  .p-highlight {
    background-color: #DEDEDE !important;
    &:focus, &:active {
      outline: none !important;
      border: none !important;
    }
  }
}
:deep(.p-paginator) {
  background-color: #F5F5F5;
  .p-highlight {
    background-color: #00ABEC !important;
    color: #ffffff !important;
  }
  .p-paginator-page {
    color: #000000;
  }

  .p-dropdown-item {
    width: 100%;
    .p-highlight {
      background: #DEDEDE !important;
      &:focus, &:active {
        outline: none !important;
        border: none !important;
      }
    }
  }
}
:deep(.p-sortable-column-icon) {
  display: none !important;
}
:deep(.p-sortable-column) {
  position: relative;
  .p-column-title {
    &::after {
      content: '';
      display: inline-block;
      width: 16px;
      height: 20px;
      margin-left: 5px;
      background-image: url('/public/img/icons/SortIcon.svg');
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
    }
  }
}

:deep(.p-inputswitch-checked) {
  .p-inputswitch-slider {
    background: #00ABEC !important;
  }
}
:deep(.p-inputswitch-slider) {
  background: #E6E6E6!important;
  height: 12px;
}
:deep(.p-inputswitch) {
  .p-inputswitch-slider {

    &::before {
      margin-top: -0.7rem !important;
      border: 2px solid #00ABEC !important;
    }

    &.p-highlight {
      background: #00ABEC !important; // Цвет при включённом состоянии (checked)
    }
  }
}

:deep(.p-checkbox-box.p-highlight) {
  background-color: #00ABEC !important;
  border-color: #00ABEC !important;
}
:deep(.p-checkbox .p-checkbox-box) {
  border-radius: 5px;
  border: 2px solid #787878;
}

:deep(.p-row-editor-save .p-row-editor-save-icon),
:deep(.p-row-editor-cancel .p-row-editor-cancel-icon) {
  fill: #787878 !important;
}

:deep(.p-row-editor-save .p-row-editor-save-icon path),
:deep(.p-row-editor-cancel .p-row-editor-cancel-icon path) {
  fill: #787878 !important;
}
:deep(.p-row-editor-save),
:deep(.p-row-editor-cancel) {
  border: 2px solid #787878 !important;
  width: 25px !important;
  height: 25px !important;

  &:hover {
    border-color: #00ABEC !important;
    path {
      fill: #00ABEC !important;
    }
  }

  &:focus {
    box-shadow: none !important;
  }
}

:deep(.p-datatable-wrapper) {
  &::-webkit-scrollbar {
    height: 5px; /* толщина горизонтального скролла */
    width: 5px; /* толщина вертикального скролла */
    background-color: #ffffff;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #00ABEC;

    &:hover {
      background-color: #00ABEC;
    }
  }
}
:deep(.p-column-filter-row .p-column-filter-menu-button) {
  display: none;
}
:deep(.p-column-filter-row .p-column-filter-clear-button) {
  display: none;
}
</style>
